import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a50deb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "name-box xag-flex-lr" }
const _hoisted_3 = { class: "money" }
const _hoisted_4 = { class: "explain" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "no-data-box xag-flex-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon" }),
  /*#__PURE__*/_createElementVNode("div", null, "暂无购买记录")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "购买记录" }),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.refreshing,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refreshing) = $event)),
      onRefresh: _ctx.onRefresh,
      class: "xag-container items-box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: _ctx.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
          finished: _ctx.finished,
          error: _ctx.error,
          "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.error) = $event)),
          "error-text": "请求失败，点击重新加载",
          onLoad: _ctx.onLoad,
          class: _normalizeClass({ 'xag-flex-center': !_ctx.items.length && _ctx.finished })
        }, {
          finished: _withCtx(() => [
            (_ctx.items.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "没有更多了"))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: i,
                onClick: ($event: any) => (_ctx.onClickItem(item))
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, _toDisplayString(item.business_name), 1),
                  _createElementVNode("div", _hoisted_3, "￥" + _toDisplayString(item.total_price), 1)
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.created_at), 1)
              ], 8, _hoisted_1))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "error", "onLoad", "class"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _hoisted_9
  ], 64))
}